import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import AboutTab from './AboutTab';
import DonationListSection from '../../components/DonationListSection/DonationListSection';
import { useTranslation } from "react-i18next";

const AboutUsPage = () => {
    const { t } = useTranslation();
    const introParagraphs = [
        'aboutus_p1',
        'aboutus_p2',
        'aboutus_p3',
        'aboutus_p4',
        'aboutus_p5'
    ];

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main about-page">
                <section className="aboutIntro">
                    <div className="container">
                        <div className="aboutPageShell">
                            <div className="aboutPageHeading">
                                <h1>{t("aboutus_title")}</h1>
                            </div>
                            <div className="aboutIntro__copy">
                                {introParagraphs.map((key) => (
                                    <p key={key}>{t(key)}</p>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
                <AboutTab />
                <section className="aboutSupport">
                    <DonationListSection />
                </section>
                <section className="aboutFiles">
                    <div className="container">
                        <div className="aboutPageShell aboutFiles__inner">
                            <Link
                                className="btn btn--styleOne btn--primary it-btn"
                                to="/files"
                                onClick={() => window.scrollTo(10, 0)}
                            >
                                <span className="btn__text">{t('files.button')}</span>
                                <i className="fa-solid fa-folder-open btn__icon" aria-hidden="true"></i>
                                <span className="it-btn__inner"></span>
                            </Link>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default AboutUsPage;
